import { render, staticRenderFns } from "./InternosDialog.vue?vue&type=template&id=d830e526"
import script from "./InternosDialog.vue?vue&type=script&lang=js"
export * from "./InternosDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports